import React from "react";
import PropTypes from "prop-types";
import {withStyles, Paper} from "@material-ui/core";
import styles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';

const baseImagePath = "../../Images/carousel/";

const FullCarousel = ({classes, images}) => (
    <div className={classes.root}>
        <Paper elevation={3}>
            <Carousel className={classes.carousel} showThumbs={false} showStatus={false} infiniteLoop
                      autoPlay interval={5000} transitionTime={1000}>
                {images.map((imageName, idx) => (
                    <div key={idx}>
                        <img src={baseImagePath + imageName} alt={""}/>
                    </div>
                ))}
            </Carousel>
        </Paper>
    </div>
);

export default withStyles(styles)(FullCarousel)

FullCarousel.propTypes = {
    classes: PropTypes.object.isRequired,
    images: PropTypes.array,
};

FullCarousel.defaultProps = {
    images: [],
};